module.exports = __webpack_public_path__ + "media/images/onboarding3-4989f2cd.png";